import React from "react";
import AuthProvidors from "../context/AuthProviders";
import Main from "../HrDashboard/components/dashboard";
import Layout from "../HrDashboard/Layout/layout";


function DashboardPage(){
    return(
        <>
        <AuthProvidors>
          <Layout>
      <Main />
      </Layout>
    </AuthProvidors>
        </>
    )
}
export default DashboardPage;